export type AccountResourceKey =
  | 'account.yourAccountSettings'
  | 'account.firstName'
  | 'account.lastName'
  | 'account.password'
  | 'account.role'
  | 'account.email'
  | 'account.resetPassword'
  | 'account.editInfo'
  | 'account.resetPasswordConfirmation'
  | 'account.login.emailRequired'
  | 'account.passwordRequired'
  | 'account.resetPassword.subject'
  | 'account.resetPassword.message'
  | 'account.newAccountResetPassword.subject'
  | 'account.newAccountResetPassword.message'
  | 'account.verificationEmailSent'
  | 'account.emailVerificationFailed'
  | 'account.emailVerificationSuccess'
  | 'account.verifyEmailExtra'
  | 'account.login.privacyBanner.title'
  | 'account.login.privacyBanner.body'
  | 'account.login.privacyBanner.privacyPolicy';

export const accountResources: Record<AccountResourceKey, string> = {
  'account.yourAccountSettings': 'Your Account Settings',
  'account.firstName': 'First Name',
  'account.lastName': 'Last Name',
  'account.email': 'Email',
  'account.password': 'Password',
  'account.role': 'Role',
  'account.resetPassword': 'Reset Password',
  'account.editInfo': 'Edit Info',
  'account.resetPasswordConfirmation': 'Are you sure you want to reset your password?',
  'account.login.emailRequired': 'Please enter the email address you registered with.',
  'account.passwordRequired': 'Password is required',
  'account.resetPassword.subject': 'Shipium Password Reset',
  'account.resetPassword.message': 'A password reset request has been generated for your account.',
  'account.newAccountResetPassword.subject': 'Shipium - Account Setup',
  'account.newAccountResetPassword.message': 'You have been invited to Shipium!',
  'account.verificationEmailSent': 'An confirmation email was sent. Please verify your email to continue.',
  'account.emailVerificationFailed':
    'We were unable to authenticate your email. Please contact your administrator for access to Shipium.',
  'account.emailVerificationSuccess':
    'Your email has been confirmed. You will receive an email when an administrator approves your request.',
  'account.verifyEmailExtra': 'Enter your company email to continue',
  // Compliance-approved copy — do not reword without sign-off. `{privacyPolicy}` marks where the
  // Privacy Policy link is spliced in.
  'account.login.privacyBanner.title': 'We Value Your Privacy',
  'account.login.privacyBanner.body':
    'We use essential cookies to ensure basic site functionality and enhance platform security. By continuing to log in to this site, you consent to our use of cookies and acknowledge our {privacyPolicy}, which outlines our data privacy practices and cookie usage.',
  'account.login.privacyBanner.privacyPolicy': 'Privacy Policy',
};
